/* eslint-disable */
class StoreManager {
  set store(options) {
    this.__Vuex = options.Vuex;
    this.__vuexStore = new this.__Vuex.Store(options.config);
  }

  get store() {
    return this.__vuexStore;
  }
}

export default StoreManager;



// WEBPACK FOOTER //
// ./src/manager/StoreManager.js